/** `base` when no existing name matches it, else the first free `base N`
 *  (N counts from 2). Comparison trims and ignores case. */
export function uniqueName(base: string, existingNames: string[]): string {
  const taken = new Set(existingNames.map((name) => name.trim().toLowerCase()));
  if (!taken.has(base.toLowerCase())) return base;
  let i = 2;
  while (taken.has(`${base.toLowerCase()} ${i}`)) i += 1;
  return `${base} ${i}`;
}
